import { createServerFn } from "@tanstack/react-start"
import { getCurrentUserId } from "@apps/gwservice/auth"
import { ctx, unsetCtx } from "@mylaunch/utils/logs"
import { withAuth } from "~/features/auth/server/auth"

type ClientErrorReportInput = {
  errorMessage: string
  stack?: string
  source?: string
  route?: string
  loggedIn: boolean
}

export const clientError = createServerFn({
  method: "POST",
})
  .inputValidator((data: ClientErrorReportInput) => data)
  .handler(({ data }) => withAuth(async (data: ClientErrorReportInput) => {
    const userId = await getCurrentUserId().catch(() => undefined)
    ctx({ userId })
    ctx({ ...data })
    unsetCtx("args")
    unsetCtx("action")
  })(data))
